var PaymentItem = function(data, selected){
	var self = this;

	self.id = ko.observable(data['id']);
	self.type = ko.observable(data['type']);
	self.type_text = ko.observable(data['type_text']);
	self.title = ko.observable(data['title']);
	self.billing_type = ko.observable(data['billing_type']);
	self.billing_period = ko.observable(data['billing_period']);
	self.billing_period_text = ko.observable(data['billing_period_text']);
	self.price = ko.observable(data['price']);
	self.price_currency = ko.observable(data['price_currency']);
	self.expiration_date = ko.observable(data['expiration_date']);

	self.selected = ko.observable(selected);

	self.formatPrice = function(){
		if(self.price())
			return parseFloat(self.price()).toFixed(2) + " " + self.price_currency();
		return "[!]";
	};

	self.toggleSelection = function(){
		self.selected(!self.selected());
	};
};